import { render } from "./TasksListV2.vue?vue&type=template&id=0d6e1000&scoped=true"
import script from "./TasksListV2.vue?vue&type=script&lang=js"
export * from "./TasksListV2.vue?vue&type=script&lang=js"

import "./TasksListV2.vue?vue&type=style&index=0&id=0d6e1000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6e1000"]])

export default __exports__